import { inject, injectable } from 'tsyringe';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import { type ICompanyUserSwitchCompanyRepository } from 'application/repositorySchemas/ICompanyUserSwitchCompanyRepository';
import { type ICompanyUserSwitchCompanyClient } from 'interfaceAdapter/gatewaySchemas/ICompanyUserSwitchCompanyClient';

@injectable()
export class CompanyUserSwitchCompanyRepository implements ICompanyUserSwitchCompanyRepository {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ICompanyUserSwitchCompanyClient')
        public readonly companyUserSwitchCompanyClient: ICompanyUserSwitchCompanyClient,
    ) {}

    public async switchCompany(companyId: number): Promise<void> {
        const { message } = await this.companyUserSwitchCompanyClient.post({
            token: this.companyUserToken.get() || '',
            company_id: companyId,
        });

        if (message) {
            throw new Error(message);
        }
    }
}
